import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Inicializar los collapses de Bootstrap dentro del accordion
    this.initializeCollapses()
  }

  initializeCollapses() {
    // Encontrar todos los elementos con data-toggle="collapse" dentro del accordion
    const collapseTriggers = this.element.querySelectorAll('[data-toggle="collapse"]')

    collapseTriggers.forEach(trigger => {
      const targetId = trigger.getAttribute('data-target')
      if (!targetId) return

      // Remover el # del inicio si existe
      const cleanTargetId = targetId.startsWith('#') ? targetId.substring(1) : targetId
      const targetElement = document.getElementById(cleanTargetId)
      if (!targetElement) return

      // Inicializar el collapse de Bootstrap si está disponible
      if (typeof bootstrap !== 'undefined' && bootstrap.Collapse) {
        let collapseInstance = bootstrap.Collapse.getInstance(targetElement)
        if (!collapseInstance) {
          collapseInstance = new bootstrap.Collapse(targetElement, {
            toggle: false
          })
        }

        // Manejar el click en el trigger
        trigger.addEventListener('click', (e) => {
          e.preventDefault()
          e.stopPropagation()
          collapseInstance.toggle()
        })

        // Actualizar aria-expanded cuando el collapse cambia
        targetElement.addEventListener('show.bs.collapse', () => {
          trigger.setAttribute('aria-expanded', 'true')
        })

        targetElement.addEventListener('hide.bs.collapse', () => {
          trigger.setAttribute('aria-expanded', 'false')
        })
      } else {
        // Fallback: manejar manualmente si Bootstrap no está disponible
        trigger.addEventListener('click', (e) => {
          e.preventDefault()
          e.stopPropagation()
          const isExpanded = targetElement.classList.contains('show')
          if (isExpanded) {
            targetElement.classList.remove('show')
            trigger.setAttribute('aria-expanded', 'false')
          } else {
            targetElement.classList.add('show')
            trigger.setAttribute('aria-expanded', 'true')
          }
        })
      }
    })
  }
}
